import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import classNames from "classnames";
import { throttle, debounce } from "throttle-debounce";
import EditContractorModal from "../../../AdminTasks/AdminContractors/EditContractorModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import contractorActions from "../../../../_actions/contractorActions";
import MultiselectTable from "../../../_common/MultiselectTable";
import { CONTRACTOR } from "../../../../_constants/actionConstants";
import projActions from "../../../../_actions/projActions";

class EditProjContractorsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pcList: [],
      deletedPcList: [],
      disabledContractors: [], // int[]
      showAddNewContractorModal: false,
      errorOnSubmit: null,
      searchString: "",
      pageCount: 1,
      currPage: 1,
    };

    this.columns = [
      { path: "name", label: "Name", isSortable: false },
      { path: "abbreviation", label: "Abbrev.", isSortable: false },
    ];

    this.searchThrottled = throttle(250, this.handleSearch);
    this.searchDebounced = debounce(250, this.handleSearch);
  }

  async componentDidMount() {
    const { dispatch, projContractorList, projectId, tabId } = this.props;

    // Prepare derived state
    let pcList = _.orderBy(
      projContractorList.map((pc) => ({ ...pc })),
      "name",
      "asc"
    );
    pcList.forEach((pc) => {
      pc.isDeleted = false;
    });

    dispatch({ type: CONTRACTOR.SET_SEARCH_WAITINGFOR, tabId, waitingFor: "" });
    // Fetch lists
    const pageCount = await dispatch(contractorActions.getPaged(tabId, 1, 50, "", true));
    this.setState({ pcList, pageCount });
  }

  componentDidUpdate(prevProps, prevState) {
    const { projContractorList, contractorsWithLinks } = this.props;
    if (contractorsWithLinks && prevProps.contractorsWithLinks !== contractorsWithLinks)
      this.setState({
        disabledContractors: contractorsWithLinks || [],
      });
    if (prevProps.projContractorList !== projContractorList) {
      let pcList = _.orderBy(
        projContractorList.map((pc) => ({ ...pc })),
        "name",
        "asc"
      );
      pcList.forEach((pc) => {
        pc.isDeleted = false;
      });
      this.setState({ pcList });
    }
  }

  componentWillUnmount() {
    const { dispatch, tabId } = this.props;
    dispatch({ type: CONTRACTOR.CLEAR_MISC_SESSION_DATA, tabId });
    dispatch({ type: CONTRACTOR.CLEAR_LIST, tabId });
  }

  getNextPage = () =>
    this.setState({ currPage: this.state.currPage + 1 }, async () => {
      const { dispatch, tabId } = this.props;
      const { currPage, searchString } = this.state;
      const pageCount = await dispatch(
        contractorActions.getPaged(tabId, currPage, 100, searchString, false)
      );
      this.setState({ pageCount });
    });

  handleSearch = async () => {
    const { searchString } = this.state;
    const { dispatch, tabId } = this.props;
    const pageCount = await dispatch(
      contractorActions.getPaged(tabId, 1, 50, searchString, true)
    );
    this.setState({ pageCount, currPage: 1 });
  };

  refreshList = async (resetList = true) => {
    const { searchString } = this.state;
    const { dispatch, tabId, projectId } = this.props;

    await dispatch(contractorActions.getAllForProject(projectId));
    const pageCount = await dispatch(
      contractorActions.getPaged(tabId, 1, 50, searchString, resetList)
    );
    this.setState({ currPage: 1, pageCount });
  };

  addContractorToProject = (contractorId) => {
    const { projectId, contractorList } = this.props;

    let deletedPcList = this.state.deletedPcList.map((dpc) => ({ ...dpc }));
    let pcList = this.state.pcList.map((pc) => ({ ...pc }));

    // If item was previously deleted, recover it. Otherwise add new.
    // (No need to compare with locationId since the incoming pcList
    // is already filtered by location.)
    const recoverablePc = deletedPcList.find((pc) => pc.contractorId === contractorId);
    if (recoverablePc) {
      recoverablePc.isDeleted = false;
      pcList.push(recoverablePc);
      deletedPcList = deletedPcList.filter(
        (pc) => pc.contractorId !== recoverablePc.contractorId
      );
    } else {
      const contractor = (contractorList || []).find(
        (c) => c.contractorId === contractorId
      );
      if (contractor) {
        const newPc = {
          projectId,
          contractorId: contractor.contractorId,
          name: contractor.name,
          abbreviation: contractor.abbreviation,
          projectAbbreviation: contractor.abbreviation,
          isPrime: false,
          phone: "",
          address: "",
          isDeleted: false,
        };
        pcList.push(newPc);
      }
    }
    this.setState({
      pcList: _.orderBy(pcList, "name", "asc"),
      deletedPcList,
    });
  };

  handleAdd = (selectedContractor) =>
    this.addContractorToProject(selectedContractor.contractorId);

  handleRemove = (selectedContractor) =>
    this.removeContractorFromProject(selectedContractor.contractorId);

  removeContractorFromProject = (contractorId) => {
    const { pcList } = this.state;
    let deletedPcList = this.state.deletedPcList.map((dpc) => ({ ...dpc }));
    const pc = pcList.find((pc) => pc.contractorId === contractorId);

    if (pc) {
      deletedPcList.push({ ...pc, isDeleted: true });
      this.setState({
        pcList: _.orderBy(
          pcList.filter((i) => i.contractorId !== contractorId),
          "name",
          "asc"
        ),
        deletedPcList,
      });
    }
  };

  handleChange_search = (e) =>
    this.setState({ searchString: e.target.value }, async () => {
      const { searchString } = this.state;
      const { dispatch, tabId } = this.props;

      let pageCount = 1;
      dispatch({
        type: CONTRACTOR.SET_SEARCH_WAITINGFOR,
        tabId,
        waitingFor: searchString,
      });

      if (!searchString) {
        pageCount = await dispatch(contractorActions.getPaged(tabId, 1, 50, "", true));
        this.setState({ currPage: 1, pageCount });
      } else if (searchString.length < 3) this.searchThrottled();
      else this.searchDebounced();
    });

  handleChange_isPrime = (rowIndex) => (e) => {
    const pcList = this.state.pcList.map((pc) => ({ ...pc }));
    pcList[rowIndex].isPrime = e.target.checked;
    pcList.forEach((pc, index) => {
      if (pc.isPrime && index !== rowIndex) pc.isPrime = false;
    });
    this.setState({ pcList });
  };

  handleClick_addContractor = () => this.toggleAddNewContractorModal();

  handleClick_removeContractor = (contractorId) => async (e) => {
    e.stopPropagation();
    e.preventDefault();
    const { projectId, dispatch } = this.props;
    const hasLinks = await dispatch(
      projActions.contractorHasLinks(projectId, contractorId)
    );
    if (!hasLinks) this.removeContractorFromProject(contractorId);
  };

  handleSubmit_pcForm = async (e) => {
    e.preventDefault();
    const { projectId, dispatch, toggleEditPcModal } = this.props;
    const projectContractors = this.state.pcList.map((pc) => ({ ...pc }));
    await dispatch(
      contractorActions.updateProjectContractorSelection(projectId, projectContractors)
    );
    toggleEditPcModal();
  };

  toggleAddNewContractorModal = () =>
    this.setState({
      showAddNewContractorModal: !this.state.showAddNewContractorModal,
    });

  renderProjContractor = () => {
    const { pcList, disabledContractors } = this.state;
    return (
      <ul className="list-group list-group-flush lg-selectedPcList border">
        {pcList &&
          pcList.map((pc, index) => {
            const isDisabled = (disabledContractors || []).includes(pc.contractorId);
            return (
              <li key={`pcRowKey_${index}`} className="list-group-item">
                <div className="form-row mb-0">
                  <div className="col-6 pl-0 pr-1">
                    <span>{pc.name}</span>
                  </div>
                  <div className="col-3 px-1">
                    <div className="form-group mb-0">
                      <div className="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          name="isPrime"
                          id={`isPrime_${index}`}
                          className="custom-control-input"
                          checked={pc.isPrime}
                          onChange={this.handleChange_isPrime(index)}
                          onClick={(e) => e.stopPropagation()}
                        />
                        <label
                          htmlFor={`isPrime_${index}`}
                          className="custom-control-label"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <b>Prime</b>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-3 pl-1">
                    <button
                      type="button"
                      name={`deletePc_${index}`}
                      id={`deletePc_${index}`}
                      className={classNames(
                        "btn btn-sm p-1 float-right",
                        { "btn-outline-danger": !isDisabled },
                        { "btn-outline-secondary": isDisabled }
                      )}
                      onClick={this.handleClick_removeContractor(pc.contractorId)}
                      disabled={isDisabled}
                    >
                      <FontAwesomeIcon icon="times" className="fa-fw" />
                    </button>
                  </div>
                </div>
              </li>
            );
          })}
      </ul>
    );
  };

  render() {
    const {
      searchString,
      pcList,
      deletedPcList,
      disabledContractors,
      showAddNewContractorModal,
      currPage,
      pageCount,
    } = this.state;
    const { contractorList, showEditPcModal, projectId, tabId, toggleEditPcModal } =
      this.props;
    const closeBtn = (
      <button className="close" onClick={toggleEditPcModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );

    return (
      <React.Fragment>
        <Modal
          isOpen={showEditPcModal}
          toggle={toggleEditPcModal}
          className={this.props.className}
          size={"xl"}
          fade={false}
        >
          <ModalHeader
            toggle={toggleEditPcModal}
            className="bg-info text-white"
            close={closeBtn}
          >
            Edit Project Contractors
          </ModalHeader>
          <ModalBody>
            <div className="d-flex flex-row">
              <div className="alert alert-info p-2 mx-2 flex-grow-1 mb-0">
                <h6>
                  <FontAwesomeIcon
                    icon="info-circle"
                    className="fa-fw align-middle mr-2"
                  />
                  Adding Contractor(s)
                </h6>
                Start by searching. If the contractor you're looking for is not on the
                list, select "Add..." link at the bottom of the list.
              </div>
            </div>
            <div className="d-flex flex-row">
              <div className="d-flex flex-column pc-cList pr-0 mr-0">
                <div className="card m-2 edit-pc-container">
                  <div className="card-body p-3">
                    <h5 className="text-muted">Search/Add Contractors</h5>
                    <div className="form-inline mb-2">
                      <div className="input-group w-100">
                        <div className="input-group-prepend">
                          <span className="input-group-text bg-lightgray">
                            <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
                          </span>
                        </div>
                        <input
                          name="searchString"
                          id="searchString"
                          className="form-control"
                          value={searchString}
                          onChange={this.handleChange_search}
                        />
                      </div>
                    </div>
                    <div className="flex-grow-1 border w-100 lg-contractorList">
                      <MultiselectTable
                        className="table table-sm table-hover"
                        data={contractorList || []}
                        selectedItems={pcList}
                        deletedItems={deletedPcList}
                        disabledItems={(contractorList || []).filter((c) =>
                          (disabledContractors || []).includes(c.contractorId)
                        )}
                        columns={this.columns}
                        idPropName={"contractorId"}
                        onSelect={this.handleAdd}
                        onDeselect={this.handleRemove}
                        disableAllSort={true}
                        isPaginated={true}
                        currPage={currPage}
                        pageCount={pageCount}
                        getNextPage={this.getNextPage}
                        searchString={searchString}
                        showAdd={(contractorList || []).length < 5 && searchString}
                        addCallback={this.toggleAddNewContractorModal}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column pc-pcList pl-0">
                <div className="card mr-2 my-2 edit-pc-container flex-grow-1">
                  <div className="card-body p-3">
                    <h5 className="text-muted">Selected Contractors for This Project</h5>
                    {this.renderProjContractor()}
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="bg-lightgray">
            <div className="form-row form-group mb-0">
              <input
                className="btn btn-primary"
                name="savePcButton"
                type="submit"
                form="pcForm"
                onClick={this.handleSubmit_pcForm}
                value="Save"
              />{" "}
              <button
                className="btn btn-secondary ml-2"
                color="secondary"
                onClick={toggleEditPcModal}
              >
                Cancel
              </button>
            </div>
          </ModalFooter>
        </Modal>
        {showAddNewContractorModal && (
          <EditContractorModal
            isNew={true}
            tabId={tabId}
            projectId={projectId}
            refreshList={this.refreshList}
            searchString={searchString}
            showEditContractorModal={showAddNewContractorModal}
            toggleEditContractorModal={this.toggleAddNewContractorModal}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  contractorsWithLinks: state.contractors.miscSessionData[ownProps.tabId]
    ? state.contractors.miscSessionData[ownProps.tabId].contractorsWithLinks
    : null,
  contractorList: state.contractors.contractorList[ownProps.tabId] || null,
  projContractorList: state.contractors.projContractorLists[ownProps.projectId] || null,
  fetching: state.contractors.fetching,
});

export default connect(mapStateToProps)(EditProjContractorsModal);
